export const DEFAULT_APP_NAME = 'New Matter Intake';
export const APP_NAME_MAX_LENGTH = 60;

/** Returns the safe header name when a setting is absent, blank, or has extra whitespace. */
export function normalizeAppName(appName) {
  const trimmed = typeof appName === 'string' ? appName.trim() : '';
  return trimmed ? trimmed.slice(0, APP_NAME_MAX_LENGTH) : DEFAULT_APP_NAME;
}

/**
 * Builds a complete replacement payload for settings/general.
 *
 * adminUpdateSettings intentionally writes this document with merge: false, so callers
 * must start with the full current snapshot and override only the fields they own. Do not
 * reduce this to an object containing only the settings displayed by one admin screen.
 */
export function preserveGeneralSettings(general, changes) {
  // useDoc adds `id` for React keys, but it is not a Firestore field and must not be
  // written into this wholesale replacement document.
  const { id, ...currentSettings } = general || {};
  return { ...currentSettings, ...changes };
}

/** Both workflow behavior toggles live in settings/general and are saved together. */
export function workflowBehaviorSettings(
  general,
  { workflowEnabled, consistencyReviewEnabled, workflowPilotUids }
) {
  const { updatedAt, updatedBy, ...settings } = preserveGeneralSettings(general, {});
  const next = { ...settings, workflowEnabled, consistencyReviewEnabled };
  // The pilot list is only meaningful while the firm-wide switch is off; an empty list is
  // dropped rather than stored, so "no pilot" reads as absent config, not as [].
  if (Array.isArray(workflowPilotUids) && workflowPilotUids.length) {
    next.workflowPilotUids = workflowPilotUids;
  } else {
    delete next.workflowPilotUids;
  }
  return next;
}
